<template lang="pug" src="./commissions.pug"></template>

<script>
import { mapState, mapGetters } from 'vuex';
import config from '../../../../config.json';

export default {
    data: () => ({
        requestProcessing: false
    }),
    computed: {
        ...mapGetters(['userBrandId']),
        ...mapState({
            items: state => state.finances.commissions.items,
            brands: state => state.data.brands,
            pagination: state => state.finances.commissions.pagination,
            filters: state => state.finances.commissions.filters
        }),
        headers() {
            const properties = [
                'title', 'countOfDrivers', 'fixedPerOrder', 'fixedPerDay',
                'perDayType', 'fixedPerWeek', 'fixedPerMonth', 'deliveryDelay',
                'isDefault', 'brandId', 'hasPrecedenceForForced'
            ];

            if (this.items.map('deletedAt').every(it => !it)) {
                properties.push('actions');
            }

            return properties.map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Commissions.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        brandId: {
            get() {
                return this.filters.brandId;
            },
            set(val) {
                return this.$store.commit('finances/SET_COMMISSIONS_BRAND_ID', val);
            }
        },
        status: {
            get() {
                return this.filters.status;
            },
            set(val) {
                this.$store.commit('finances/SET_COMMISSIONS_STATUS', val);
            }
        },
        title: {
            get() {
                return this.filters.title;
            },
            set(val) {
                return this.$store.commit('finances/SET_COMMISSIONS_TITLE', val);
            }
        },
        commissionStatuses() {
            return config.commissionStatuses.map(status => ({
                title: this.$vuetify.lang.t(`$vuetify.pages.Commissions.statusesList.${status}`),
                value: status
            }));
        }
    },
    created() {
        if (this.userBrandId) {
            this.brandId = this.userBrandId;
        }

        this.$store.dispatch('data/getBrands').then(() => {
            if (!this.brandId) {
                this.brandId = this.brands && this.brands[0] && this.brands[0].id;
            }

            this.loadItems();
        });
    },
    methods: {
        loadItems(page = 1) {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('finances/getCommissions', Object.assign({}, {
                ...this.filters,
                page
            })).then(() => {
                this.$nextTick(() => this.requestProcessing = false);
            });
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadItems(page);
            }
        }
    }
};
</script>
